import { render } from "./AllClients.vue?vue&type=template&id=6688be46"
import script from "./AllClients.vue?vue&type=script&lang=js"
export * from "./AllClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__